import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { cfetch } from '@confluence/network';

export async function fetchShortcutEnabledState(): Promise<boolean> {
	let enabled = false;

	try {
		const res = await cfetch('/wiki/rest/confluenceshortcuts/latest/enabled');
		if (res.ok) {
			enabled = (await res.text()) === 'true';
		}
	} catch (e) {
		getMonitoringClient().submitError(
			new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`),
			{ attribution: Attribution.BACKBONE },
		);
	}

	return (window.__SHORTCUT_ENABLED__ = enabled);
}

export async function preloadShortcutEnabledState(): Promise<boolean> {
	const { isLoggedIn, isLicensed } = getPreloaderFnContext();
	if (isLoggedIn && isLicensed) {
		return await fetchShortcutEnabledState();
	}
	return false;
}
